import { defineMessages } from 'react-intl';

const point14Messages = defineMessages({
    splice: {
        id: 'splice-point-point14',
        defaultMessage: 'Splice',
    },
    port: {
        id: 'port-point-point14',
        defaultMessage: 'Port',
    },
    opticalport: {
        id: 'opticalport-point-point14',
        defaultMessage: 'Optical port',
    },
    opticalPorts: {
        id: 'opticalports-point-point14',
        defaultMessage: 'Optical ports',
    },
    opticalSwitchPport: {
        id: 'opticalswitchport-point-point14',
        defaultMessage: 'SFP {sfp} Port {port}',
    },
    opticalodfport: {
        id: 'opticalodfport-point-point14',
        defaultMessage: 'Port',
    },
    opticalSwitchPortShort: {
        id: 'opticalswitchport-point-short',
        defaultMessage: 'OSP',
    },
    opticalOdfportShort: {
        id: 'opticalodfport-point-short',
        defaultMessage: 'OOP',
    },
    isFactory: {
        id: 'splice-is-factory',
        defaultMessage: 'Is factory',
    },
});

export default point14Messages;
